module.exports = __webpack_public_path__ + "img/postman.e72c0186.png";